import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const UserApi = createApi({
  reducerPath: "UserApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["UserApi"],
  endpoints: (build) => ({
    getAllUsers: build.query({
      query: () => ({
        url: `/index.php?VALUE=user`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["UserApi"],
    }),

    //     getTeacherById: build.query({
    //       query: ({ id }) => ({
    //         url: `/teachers/${id}`,
    //         method: "GET",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       providesTags: ["UserApi"],
    //     }),

    //     editTeacher: build.mutation({
    //       query: ({ id, data }) => ({
    //         url: `/teachers/${id}`,
    //         method: "PUT",
    //         body: data,
    //         headers: {},
    //       }),
    //       invalidatesTags: ["UserApi"],
    //     }),

    //     addTeacher: build.mutation({
    //       query: (data) => ({
    //         url: `/teachers`,
    //         method: "POST",
    //         body: data,
    //         headers: {},
    //       }),
    //       invalidatesTags: ["UserApi"],
    //     }),

    //     deleteTeacher: build.mutation({
    //       query: (id) => ({
    //         url: `/teachers/${id}`,
    //         method: "DELETE",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       invalidatesTags: ["UserApi"],
    //     }),
  }),
});

export const { useGetAllUsersQuery } = UserApi;
